import { type Account } from "@umami/chains";
import { useAvailableMultichainNetworks, useGetNetworkByFullId, useGetWallets } from "@umami/state";

import { useFilter } from "@/hooks/useFilter";

export const useNetworkSelector = (account = {} as Account) => {
  const wallets = useGetWallets(account);
  const { networks } = useAvailableMultichainNetworks();
  const getNetwork = useGetNetworkByFullId();

  const source = wallets.length > 0 ? wallets.map(w => getNetwork(w.chainId)) : networks;
  const { setInput, data } = useFilter(
    source,
    (network, input) =>
      network.name.toLowerCase().includes(input) || network.chain.toLowerCase().includes(input)
  );

  return {
    setInput,
    filteredChains: data,
  };
};
